var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTabNotificationIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3_330",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9187 22.8469L24.4969 18.6469L24.375 11.25C24.379 11.2001 24.379 11.1499 24.375 11.1C23.2969 5.23125 19.8844 1.875 15 1.875C9.84375 1.875 5.7 5.625 4.6875 11.0812C4.68242 11.1374 4.68242 11.1939 4.6875 11.25L4.56562 18.75L2.00625 22.95C1.92396 23.0925 1.88065 23.2542 1.88065 23.4187C1.88065 23.5833 1.92396 23.745 2.00625 23.8875C2.08565 24.0327 2.20207 24.1543 2.34368 24.2399C2.48529 24.3255 2.64704 24.3721 2.8125 24.375H11.25C11.25 25.3696 11.6451 26.3234 12.3483 27.0266C13.0516 27.7299 14.0054 28.125 15 28.125C15.9946 28.125 16.9484 27.7299 17.6516 27.0266C18.3549 26.3234 18.75 25.3696 18.75 24.375H27.1875C27.3642 24.3745 27.5372 24.3241 27.6865 24.2295C27.8357 24.135 27.9553 24.0002 28.0312 23.8406C28.1082 23.6813 28.1385 23.5034 28.1186 23.3275C28.0987 23.1516 28.0294 22.985 27.9187 22.8469ZM15 26.25C14.5027 26.25 14.0258 26.0525 13.6742 25.7008C13.3225 25.3492 13.125 24.8723 13.125 24.375H16.875C16.875 24.8723 16.6775 25.3492 16.3258 25.7008C15.9742 26.0525 15.4973 26.25 15 26.25ZM4.47187 22.5L6.34687 19.4625C6.43113 19.3205 6.47641 19.1588 6.47812 18.9937L6.5625 11.3438C7.41562 6.79688 10.8 3.75 15 3.75C20.2781 3.75 21.9656 8.4375 22.5 11.3438L22.6312 18.9937C22.6325 19.2052 22.7052 19.4101 22.8375 19.575L25.2187 22.5H4.47187Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3_330)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -11.25,
    y: -14.0625,
    width: 52.8,
    height: 56.1,
    fill: "#DBE9F6"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabNotificationIcon);
export default __webpack_public_path__ + "static/media/tabNotificationIcon.ded3f1be88d942c287f9cbd34216b514.svg";
export { ForwardRef as ReactComponent };